var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',_vm._g({class:_vm.svgClass,style:({ fill: _vm.iconColor, width: _vm.width + 'px', height: _vm.height + 'px' }),attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.svgIconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }